export default {
    // 高级定制类型
    MTM_TYPE_PERSON: 1,
    // 精品定制类型
    MTM_TYPE_SINGLE: 2,
    // 团体定制类型
    MTM_TYPE_GROUP: 3,
    // 标码定制类型
    MTM_TYPE_SIZE: 4,

    // 基准颜色横向长度
    COLOR_BASE_X: 87.65,
    // 基准颜色纵向长度
    COLOR_BASE_Y: 82.81,
    // 相机初始化视角
    CAMERA_FOV: 40,
    // 单次放大步进值
    STEP_CLICK_FOV: 3,
    // 滚轮缩放步进值
    STEP_WHEEL_FOV: 0.015
}
